import React from "react";
import ProjectMapPage from "./ProjectMapPage";
import geojsonData from "../geojsonData/AchieversPhase2";

const AchieversPhase2 = () => {
  const projectId = "PRJ00066";
  const title = "Achievers’ Paradise – Ngong, Kimuka Phase 2";

  const mapConfig = {
    minZoom: 13,
    zoom: 15,
    bounds: [
      [61.66, 18.6],
      [61.6, 18.67],
    ],
    // No overlays active in original file
    searchPrefix: "og",
  };

  return (
    <ProjectMapPage
      projectId={projectId}
      title={title}
      geojsonData={geojsonData}
      mapConfig={mapConfig}
      viewProjectLink="https://www.optiven.co.ke/plots-in-ngong/achievers-paradise-ngong-kimuka-phase2/"
      fillOfferLink="https://docs.google.com/forms/d/e/1FAIpQLSeq-h_ydPVfvofXJj1FNvHBRtB_f7soDmVfM2Bvquy4H7L6VA/viewform"
    />
  );
};

export default AchieversPhase2;
